import _ from 'lodash';
import { createSelector } from 'reselect';

import reducerUtils from 'app/reducers/utils';



/*
 *  Actions
 */

const Types = {
  LOAD_PAGE: 'RGB_LOAD_PAGE',
  SET_RGB: 'RGB_SET_RGB',
  SET_R: 'RGB_SET_R',
  SET_G: 'RGB_SET_G',
  SET_B: 'RGB_SET_B',
};

const Ax = {

  loadPage: () => (dispatch, getState) => {
    // dispatch(Ax.pickRand());
    return dispatch({type: Types.LOAD_PAGE});
  },

  pickRand: () => (dispatch, getState) => {
    const r = _.random(0, 255);
    const g = _.random(0, 255);
    const b = _.random(0, 255);
    return dispatch(Ax.setRgb(r, g, b));
  },

  setRgb: (r=0, g=0, b=0) => ({type: Types.SET_RGB, r, g, b}),
  setR: (r=0) => ({type: Types.SET_R, r}),
  setG: (g=0) => ({type: Types.SET_G, g}),
  setB: (b=0) => ({type: Types.SET_B, b}),

};



/*
 *  Reducer
 */

const initialState = {
  r: 0,
  g: 0,
  b: 0,
};

const reducer = reducerUtils.createReducer(initialState, {

  [Types.SET_RGB]: (state, {r, g, b}) => {
    return {...state, r, g, b};
  },

  [Types.SET_R]: (state, {r}) => {
    return {...state, r};
  },
  [Types.SET_G]: (state, {g}) => {
    return {...state, g};
  },
  [Types.SET_B]: (state, {b}) => {
    return {...state, b};
  },

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selR = (state) => state.tylerRgb.r;
  const selG = (state) => state.tylerRgb.g;
  const selB = (state) => state.tylerRgb.b;

  return {
    r: selR,
    g: selG,
    b: selB,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
